import React, { useState, useEffect, useRef } from 'react';
import { Grid, TextField, Box, Button, Typography } from '@mui/material';
import { chaptaContainer, formContainerStyle, formMainTitleStyle, primeryButtunStyle } from '../../Statics/index'
import { tokens } from '../../../../theme';
import { useTheme } from "@mui/material";
import { motion } from "framer-motion";
import { CaptchaVector } from './Vector/CaptchaVector';
import PrimaryButton from "../../../../General/Components/PrimaryButton/PrimaryButton";




const Captcha = ({ setShowCaptcha,setRememberState}) => {
    const theme = useTheme();
    const ref = useRef(null);
    const [isDisabled, setIsDisabled] = useState(true);


    const colors = tokens(theme.palette.mode);
    const MotionGridItem = motion(Grid);
    const [correctAnswer, setCorrectAnswer] = useState(0)

    const [capNumber, setCapNumber] = useState({
        number1: 0,
        number2: 0,
    });

    useEffect(() => {
        const num1 = Math.floor(Math.random() * 10);
        const num2 = Math.floor(Math.random() * 10);
        setCapNumber({
            number1: num1,
            number2: num2,
        });

        setCorrectAnswer(num1 + num2);

    }, [])

  



    const checkCaptch = () => {
        let answer = ref.current.value;
        if (answer == correctAnswer) {
            setShowCaptcha(false);
            setRememberState((prev)=>({...prev,'updateLogInCount':true}))
        }
    }

    return (<Box sx={{ ...formContainerStyle }}>
        <Grid
            container
            sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
            }}
        >
            <MotionGridItem
                item
                xs={12}
                sm={8}
                md={6}
                variants={{
                    hidden: { opacity: 0, y: 30, scale: 0.98 },
                    visible: {
                        opacity: 1,
                        y: 0,
                        scale: 1,
                        transition: {
                            duration: 0.7,
                            ease: [0.22, 1, 0.36, 1],
                        },
                    },
                }}
                initial="hidden"
                animate="visible"
                sx={{
                    bgcolor: "white",
                    boxShadow: { xs: 2, sm: 4 },
                    borderRadius: { xs: 2, sm: 5 },
                    py: { xs: 4, sm: 8 },
                    px: { xs: 3, sm: 5 },
                    mx: "auto",
                    overflow: "hidden",
                }}
            >
                <Box sx={{ display: "flex", flex: 1 }}>
                    <Box sx={{ width: { xs: '100%' }, p: 3, borderRadius: 3, boxShadow: 2 }}>
                        <Grid item xs={12} lg={12} sx={{ minHeight: "2rem" }}>
                            <Typography sx={{ textAlign: 'center' }} variant={'body2'} pb={2}  >
                                جواب صحیح را وارد کنید
                            </Typography>
                        </Grid>


                        <Grid item xs={12} lg={12} sx={{ minHeight: "5rem" }}>
                            <CaptchaVector number1={capNumber?.number1} number2={capNumber?.number2} />
                        </Grid>


                        <Grid item xs={12} lg={12}>
                            <TextField
                                sx={{
                                    "& .MuiInputBase-input": {
                                        padding: "0.8rem",
                                    },
                                }}
                                id="outlined-basic"
                                label="جواب صحیح"
                                variant="outlined"
                                fullWidth
                                inputRef={ref}
                                inputProps={{
                                    step: 1,     // فقط عدد صحیح
                                    min: 0       // اگر منفی هم نمی‌خوای
                                }}
                                onKeyDown={(e) => {
                                    if ([".", ",", "e", "-", "+"].includes(e.key)) {
                                        e.preventDefault();
                                    }
                                }}
                                onChange={(e) => {
                                    // جلوگیری از paste اعشاری
                                    e.target.value = e.target.value.replace(/[^0-9]/g, "");
                                    // setIsDisabled(!ref.current?.value);

                                }}

                            />

                        </Grid>

                        <Grid item xs={12} lg={12}>

                            <PrimaryButton
           
                                sx={{
                                    ...primeryButtunStyle,
                                    backgroundColor: colors.primary[600],
                                    my: 2

                                }}
                                label={'ثبت'}
                                onClick={checkCaptch}


                            />
                        </Grid>

                    </Box>
                </Box>
            </MotionGridItem>
        </Grid>
    </Box>












    )
}

export default Captcha